import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Dropdown, Image, Tab, OverlayTrigger, Tooltip, Button, Modal, ModalFooter } from 'react-bootstrap'
import Card from '../../components/Card'
import { Link, useNavigate, Route } from 'react-router-dom'
import Moment from 'moment';
import { apiHandler } from '../../api/apihandler';
import { AD_CLICK, AD_LIST, AD_VIEW, FEED_LIKE, FEED_LIKES } from '../../api/constants'
import Swal from 'sweetalert2'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import ImageSlider from "../ImageSlider";
import { InView } from "react-intersection-observer";
import CommentBox from '../comment/commentBox';
import CommentList from '../comment/commentList';
import ReadMoreText from '../readMoreText';

import likeFillIcon from '../../assets/images/icon/like_fill_icon.png'
import likeIcon from '../../assets/images/icon/like_icon.png'
import playButton from '../../assets/images/icon/play_button.png'


const MiddleAdCard = ({ index, adsPageVal, updateAdsPageVal }) => {
    const navigate = useNavigate();
    const [adsList, setAdsList] = useState([]);
    const [feedLikeUserList, setFeedLikeUserList] = useState([]);
    const [showLikesList, setShowLikesList] = useState(false);
    const [refreshCommentList, setRefreshCommentList] = useState(false);
    const [show, setShow] = useState(false);

    const [imageController, setImageController] = useState({
        toggler: false,
        slide: 1
    });
    function imageOnSlide(number) {
        setImageController({
            toggler: !imageController.toggler,
            slide: number
        });
    }
    const handleClose = () => {
        setShow(false);
    }
    const handleShow = () => {
        setShow(true);
    }

    useEffect(() => {
        if ((index + 1) % 3 === 0) {
            getMiddleAdsList(adsPageVal)
            // getMiddleAdsList((index + 1) > 3? ((index + 1)/3):1)
        }
    }, []);


    async function getFeedLike(postId) {
        if (localStorage.getItem("uzoneAuthToken")) {
            // setShowLoader(true)
            try {
                const res = await apiHandler(FEED_LIKE, "POST", {
                    post_id: postId
                })
                if (res.data?.response?.status === 200) {
                    // Swal.fire({
                    //     title: 'Success',
                    //     text: res?.response?.data?.data?.message,
                    //     icon: 'success',
                    //     confirmButtonText: 'Okay'
                    // })
                    if (adsList[0]?.is_like === 1) {
                        adsList[0]['is_like'] = 0
                        adsList[0]['like_count'] = adsList[0]?.like_count - 1
                    } else {
                        adsList[0]['is_like'] = 1
                        adsList[0]['like_count'] = adsList[0]?.like_count + 1
                    }
                    getFeedLikesUserList(adsList[0]?.id)
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: res?.response?.data?.data?.message,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                }
            } catch (error) {
                console.error(error);
            }
            finally {
                // setShowLoader(false)
            }
        } else {
            navigate('/auth/sign-in')
        }
    }

    async function getFeedLikesUserList(postId) {
        try {
            const res = await apiHandler(FEED_LIKES, "POST", {
                post_id: postId
            })
            if (res.data?.response?.status === 200) {
                setFeedLikeUserList(res?.data?.data?.userLikes)
            } else {
                // Swal.fire({
                //     title: 'Error',
                //     text: res?.response?.data?.data?.message,
                //     icon: 'error',
                //     confirmButtonText: 'Okay'
                // })
            }
        } catch (error) {
            console.error(error);
        }
        finally {
        }
    }

    async function getMiddleAdsList(pageVal) {
        try {
            const res = await apiHandler(AD_LIST, "POST", {
                page: pageVal,
                limit: 1,
                position: "2"
            })
            if (res.data?.response?.status === 200) {
                // setAdsMaxPage(res?.data?.data?.userPosts?.meta?.last_page)
                if (pageVal <= res?.data?.data?.userPosts?.meta?.last_page) {
                    await updateAdsPageVal(pageVal + 1)
                } else {
                    getMiddleAdsList(1)
                    // await updateAdsPageVal(1)
                    // adsPageVal(1)
                }
                if (res?.data?.data?.userPosts?.meta?.total > 0) {
                    setAdsList(adsList.concat(res?.data?.data?.userPosts?.data))
                }
            }
        } catch (error) {
            console.error(error);
        }
    }

    async function getAdView() {
        try {
            const res = await apiHandler(AD_VIEW, "POST", {
                ad_id: adsList[0]?.id,
                device_type: 0,
            })
            // if (res.data?.response?.status === 200) {
            //     console.log("Ad view working..........")
            // }
        } catch (error) {
            console.error(error);
        }
    }

    async function getAdClick() {
        try {
            const res = await apiHandler(AD_CLICK, "POST", {
                ad_id: adsList[0]?.id,
                device_type: 0,
            })
            // if (res.data?.response?.status === 200) {

            // }
        } catch (error) {
            console.error(error);
        }
    }

    const loadView = (inView) => {
        if (inView) {
            getAdView()
        }
    };

    return (
        <>
            {
                adsList?.length > 0 ?
                    <Card>
                        <Card.Body>
                            <div className="post-item">
                                {/* <div className="user-post-data pb-3">
                            <div className="d-flex justify-content-between">
                                <div className="me-3">
                                    <img loading="lazy" className="rounded-circle  avatar-45"
                                        src={adsList[0]?.user?.user_setting?.photo ? adsList[0]?.user?.user_setting?.photo : "https://uzone360live.s3.amazonaws.com/noimage.png"} alt="" />
                                </div>
                                <div className="w-100">
                                    <div className="d-flex justify-content-between flex-wrap">
                                        <div>
                                            <h5 className="mb-0 d-inline-block"><Link to={profileData?.user_type === 4 ? "#" : `/dashboard/app/friend-profile/${adsList[0]?.user?.slug}`}>{adsList[0]?.user?.first_name + " " + adsList[0]?.user?.last_name}</Link></h5>
                                            <p className="mb-0">{Moment(adsList[0]?.created_at).format('MMM D YYYY')}</p>
                                        </div>
                                        <div className="card-post-toolbar">
                                            <Dropdown>
                                                <Dropdown.Toggle variant="bg-transparent">
                                                    <span className="material-symbols-outlined">
                                                        more_horiz
                                                    </span>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu className=" m-0 p-0">
                                                    {
                                                        adsList[0]?.is_own === 1 ?
                                                            <Dropdown.Item className=" p-3" to="#">
                                                                <div className="d-flex align-items-top"
                                                                    onClick={() =>
                                                                        Swal.fire({
                                                                            title: 'Warning!',
                                                                            text: 'Are you sure, want to delete this feed?',
                                                                            icon: 'warning',
                                                                            showCancelButton: true,
                                                                            showConfirmButton: true,
                                                                            cancelButtonText: 'Cancel',
                                                                            confirmButtonText: 'Confirm',
                                                                            confirmButtonColor: "#5c518b"
                                                                        }).then((result) => {
                                                                            if (result.isConfirmed) {
                                                                                getFeedDelete(adsList[0]?.id)
                                                                            }
                                                                        })}>
                                                                    <i className="ri-delete-bin-7-line h4"></i>
                                                                    <div className="data ms-2">
                                                                        <h6>Delete</h6>
                                                                        <p className="mb-0">Remove this Post from your profile</p>
                                                                    </div>
                                                                </div>
                                                            </Dropdown.Item> : null
                                                    }
                                                    <Dropdown.Item className=" p-3" to="#">
                                                        <div className="d-flex -top">
                                                            <i className="ri-flag-2-line h4"></i>
                                                            <div className="data ms-2">
                                                                <h6>Report Flag</h6>
                                                                <p className="mb-0">Flag reason for this post .</p>
                                                            </div>
                                                        </div>
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                                <div className="d-flex justify-content-between">
                                    <div className="me-3">
                                        <img loading="lazy" className="rounded-circle  avatar-45"
                                            src={adsList[0]?.user?.user_setting?.photo ? adsList[0]?.user?.user_setting?.photo : "https://uzone360live.s3.amazonaws.com/noimage.png"} alt="" />
                                    </div>
                                    <div className="w-100">
                                        <div className="d-flex justify-content-between flex-wrap">
                                            <div>
                                                <h5 className="mb-0 d-inline-block"><Link to={`/dashboard/app/friend-profile/${adsList[0]?.user?.slug}`}>{adsList[0]?.user?.first_name + " " + adsList[0]?.user?.last_name}</Link></h5>
                                                {/* <p className="ms-1 mb-0 d-inline-block">Add New Post</p> */}
                                                <p className="mb-0">Sponsored</p>
                                            </div>
                                            <div className="card-post-toolbar">
                                                <Link to={adsList[0]?.user_post_ad?.ad_link} target='_blank noopener,noreferrer' onClick={() => getAdClick()}>
                                                    <button type="submit" className="btn btn-primary d-block w-20">
                                                        {adsList[0]?.user_post_ad?.button_text}</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between flex-wrap">
                                    <div>
                                        {
                                            adsList[0]?.user_post_ad?.title ?
                                                <div className="mt-0">
                                                    <h5><Link to="#">{adsList[0]?.user_post_ad?.title}</Link></h5>
                                                </div> : null
                                        }
                                        {
                                            adsList[0]?.content ?
                                                <div className="mt-0">
                                                    <h6>{adsList[0]?.content}</h6>
                                                </div> : null
                                        }
                                    </div>
                                </div>

                                <div className="user-post">
                                    <Link to={adsList[0]?.user_post_ad?.ad_link} target='_blank noopener,noreferrer' onClick={() => getAdClick()}>
                                        <ImageSlider images={adsList[0]?.user_post_images} />
                                        {/* <ResponsiveMasonry
                                            columnsCountBreakPoints={{ 350: 1, 750: 1, 900: 1 }}>
                                            <Masonry columnsCount={3} gutter="10px">
                                                {adsList[0]?.user_post_images.map((image, i) => (
                                                    // image?.media_type === 1 ?
                                                    //     <div key={image?.id}>
                                                    //         <div className="img-fluid" style={{ position: "relative" }} >
                                                    //             <img loading="lazy"
                                                    //                 src={image?.thumb} alt="gallary" className="img-fluid" />
                                                    //         </div>
                                                    //         <Link style={{ position: "absolute", left: "47%", top: "47%", zIndex: 1 }}>
                                                    //             <img style={{ height: 50, width: 50 }} src={playButton} />
                                                    //         </Link>
                                                    //     </div> :
                                                    <img key={image?.id} loading="lazy" src={image?.image_path}
                                                        alt="post" className="img-fluid w-100" />
                                                ))}
                                            </Masonry>
                                        </ResponsiveMasonry> */}
                                    </Link>
                                </div>
                                <div className="d-flex justify-content-between flex-wrap mt-2">
                                    <div>
                                        <div className="d-flex align-items-center">
                                            <div>
                                                <h6 className="mb-0 d-inline-block">
                                                    {
                                                        adsList[0]?.is_like === 1 ?
                                                            <img loading="lazy" src={likeFillIcon} alt="icon" style={{ marginTop: "-2px", cursor: "pointer" }}
                                                                onClick={() => { getFeedLike(adsList[0]?.id) }} /> :
                                                            <img loading="lazy" src={likeIcon} alt="icon" style={{ marginTop: "-5px", cursor: "pointer" }}
                                                                onClick={() => { getFeedLike(adsList[0]?.id) }} />
                                                    }
                                                    {
                                                        adsList[0]?.is_like === 1 ?
                                                            adsList[0]?.like_count > 1 ?
                                                                <Link to="#"
                                                                    onMouseEnter={() => setShowLikesList(true)}
                                                                    onMouseLeave={() => setShowLikesList(false)}>
                                                                    You and {((adsList[0]?.like_count) - 1) + " "} others
                                                                </Link> :
                                                                <Link to="#"
                                                                    onMouseEnter={() => setShowLikesList(true)}
                                                                    onMouseLeave={() => setShowLikesList(false)}>
                                                                    You like
                                                                </Link> :
                                                            <Link to="#" style={{ marginLeft: "6px" }}
                                                                onMouseEnter={() => setShowLikesList(true)}
                                                                onMouseLeave={() => setShowLikesList(false)}>
                                                                {adsList[0]?.like_count + " "}like
                                                            </Link>
                                                    }
                                                </h6>
                                                <h6 className="mb-0 d-inline-block" style={{ marginLeft: "10px" }}>
                                                    <Link to="#" onClick={handleShow}
                                                    >{adsList[0]?.comment_count + " "}Comment</Link>
                                                </h6>
                                            </div>

                                            {
                                                showLikesList ?
                                                    <div className="card-header-toolbar d-flex align-items-center" style={{ position: "absolute" }}
                                                        onMouseEnter={() => setShowLikesList(true)}
                                                        onMouseLeave={() => setShowLikesList(false)}>
                                                        <Dropdown>
                                                            <Card className="dropdown-menu-right cardBackgroundColor">
                                                                <div style={{ backgroundColor: "#e4f0f1", margin: "1px" }}>
                                                                    {
                                                                        feedLikeUserList ?
                                                                            feedLikeUserList?.map((elm, i) => (
                                                                                <Dropdown.Item
                                                                                    key={elm?.id}
                                                                                    href={`/dashboard/app/friend-profile/${elm?.user?.slug}`} >
                                                                                    {elm?.user?.first_name + " " + elm?.user?.last_name}
                                                                                </Dropdown.Item>
                                                                            )) : null
                                                                    }
                                                                </div>
                                                            </Card>
                                                        </Dropdown>
                                                    </div> : null
                                            }
                                        </div>
                                        {/* {
                                            adsList[0]?.user_post_ad?.description ?
                                                <div className="mt-0">
                                                    <h6>{adsList[0]?.user_post_ad?.description}</h6>
                                                </div> : null
                                        } */}
                                    </div>
                                    <div>
                                        {/* <Link to={adsList[0]?.user_post_ad?.ad_link} target='_blank noopener,noreferrer' onClick={() => getAdClick()}>
                                            <button type="submit" className="btn btn-primary d-block w-20">
                                                {adsList[0]?.user_post_ad?.button_text}</button>
                                        </Link> */}
                                    </div>
                                </div>
                                <Modal scrollable={true} show={show} onHide={handleClose} size="lg" style={{ marginTop: 80, maxHeight: "650px" }}>
                                    <Modal.Header className="d-flex justify-content-between">
                                        <div className="d-flex justify-content-between">
                                            <div className="me-3">
                                                <img loading="lazy" className="rounded-circle  avatar-40"
                                                    src={adsList[0]?.user?.user_setting?.photo ? adsList[0]?.user?.user_setting?.photo : "https://uzone360live.s3.amazonaws.com/noimage.png"} alt="" />
                                            </div>
                                            <div className="w-100">
                                                <div className="d-flex justify-content-between flex-wrap">
                                                    <div>
                                                        <h5 className="mb-0 d-inline-block"><Link to="#">{adsList[0]?.user?.first_name + " " + adsList[0]?.user?.last_name}</Link></h5>
                                                        <p className="mb-0">Sponsored</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <button type="button" className="btn btn-secondary lh-1" onClick={handleClose} ><span className="material-symbols-outlined">close</span></button>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <div className="post-item" style={{ maxHeight: "500px" }}>
                                            {
                                                adsList[0]?.content ?
                                                    adsList[0]?.user_post_images?.length > 0 ?
                                                        <ReadMoreText txtData={adsList[0]?.content} maxLength={150} /> :
                                                        <ReadMoreText txtData={adsList[0]?.content} maxLength={1000} /> : null
                                            }
                                            <div className="user-post">
                                                <Link to="#">
                                                    <ResponsiveMasonry
                                                    >
                                                        <Masonry columnsCount={3} gutter="10px">
                                                            {adsList[0]?.user_post_images.map((image, i) => (
                                                                image?.media_type === 1 ?
                                                                    <div key={image?.id} onClick={() => {
                                                                        imageOnSlide(i + 1)
                                                                    }}>
                                                                        <div className="img-fluid" style={{ width: 200, height: 200 }} >
                                                                            <img style={{ height: 200, width: 200, marginRight: "17px", }} loading="lazy"
                                                                                src={image?.thumb} alt="gallary" className="img-fluid" />

                                                                        </div>
                                                                        <Link style={{ position: "absolute", marginTop: "-123px", marginLeft: "70px", zIndex: 1 }}>
                                                                            <img style={{ height: 50, width: 50 }} src={playButton} />
                                                                        </Link>
                                                                    </div> :
                                                                    <img key={image?.id} loading="lazy" src={image?.image_path}
                                                                        alt="post" className="img-fluid w-100"
                                                                        onClick={() => {
                                                                            imageOnSlide(i + 1)
                                                                        }} />
                                                            ))}
                                                        </Masonry>
                                                    </ResponsiveMasonry>
                                                </Link>
                                            </div>
                                            <div className="like-block position-relative d-flex align-items-center">
                                                <div className="d-flex align-items-center">
                                                    <div style={{ marginTop: "10px" }}>
                                                        <h6 className="mb-0 d-inline-block" style={{ cursor: "pointer" }}
                                                            onClick={() => { getFeedLike(adsList[0]?.id) }}>
                                                            {
                                                                adsList[0]?.is_like === 1 ?
                                                                    <img loading="lazy" src={likeFillIcon} alt="icon" className="img-fluid" style={{ marginTop: "-2px" }} /> :
                                                                    <img loading="lazy" src={likeIcon} alt="icon" className="img-fluid" style={{ marginTop: "-5px" }} />
                                                            }

                                                            {
                                                                adsList[0]?.is_like === 1 ?
                                                                    adsList[0]?.like_count > 1 ?
                                                                        <Link to="#">You and {((adsList[0]?.like_count) - 1) + " "} others</Link> :
                                                                        <Link to="#">You like</Link> :
                                                                    <Link to="#" style={{ marginLeft: "6px" }}>{adsList[0]?.like_count + " "}like</Link>
                                                            }
                                                        </h6>
                                                        <h6 className="mb-0 d-inline-block" style={{ marginLeft: "10px" }}>
                                                            <Link to="#" onClick={handleShow}
                                                            >{adsList[0]?.comment_count + " "}Comment</Link>
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <CommentList postId={adsList[0]?.id} refreshCommentList={refreshCommentList} setRefreshCommentList={setRefreshCommentList} />
                                        </div>
                                    </Modal.Body>
                                    <ModalFooter>
                                        <div className="w-100">
                                            <CommentBox postId={adsList[0]?.id} commentId={""} setRefreshCommentList={setRefreshCommentList} />
                                        </div>
                                    </ModalFooter>
                                </Modal>
                                {/* <div className="comment-area mt-4">
                            <div className="d-flex justify-content-between align-items-center flex-wrap">
                                <div className="like-block position-relative d-flex align-items-center">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <h6 className="mb-0 d-inline-block" style={{ marginLeft: "10px" }}>
                                                <Link to="#"
                                                >{adsList[0]?.comment_count + " "}Views</Link>
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div> */}
                            </div>
                        </Card.Body>
                    </Card> :
                    null
            }

            <InView as="div" onChange={(inView, entry) => loadView(inView)} />
        </>
    )
}

export default MiddleAdCard